import {
    GET_ALL_PROJECTS_REQUESTED,
    GET_ALL_PROJECTS_SUCCEEDED,
    GET_ALL_PROJECTS_FAILED,
    GET_ALL_PLACES_REQUESTED,
    GET_ALL_PLACES_SUCCEEDED,
    GET_ALL_PLACES_FAILED,
    GET_ALL_ZONES_REQUESTED,
    GET_ALL_ZONES_SUCCEEDED,
    GET_ALL_ZONES_FAILED,
    GET_PLACES_REQUESTED,
    GET_PLACES_SUCCEEDED,
    GET_PLACES_FAILED,
    CREATE_PROJECT_REQUESTED,
    CREATE_PROJECT_SUCCEEDED,
    CREATE_PROJECT_FAILED,
    EDIT_PLACE_REQUESTED,
    EDIT_PLACE_SUCCEEDED,
    EDIT_PLACE_FAILED,
    ASSIGN_PLACES_REQUESTED,
    ASSIGN_PLACES_SUCCEEDED,
    ASSIGN_PLACES_FAILED,
    STATUS,
    SET_PROJECT,
    SET_STATUS,
    SET_PLACES,
    SET_ZONE,
    SET_ACTIVE_PLACE_ID,
    RESEARCHERS_REQUESTED,
    RESEARCHERS_SUCCEEDED,
    RESEARCHERS_FAILED,
    ASSIGNEE_REQUESTED,
    ASSIGNEE_SUCCEEDED,
    ASSIGNEE_FAILED,
    RESET_PLACE_DETAIL,
    DELETE_PLACE_REQUESTED,
    DELETE_PLACE_SUCCEEDED,
    DELETE_PLACE_FAILED,
    UNASSIGN_RESEARCHER_REQUESTED,
    UNASSIGN_RESEARCHER_SUCCEEDED,
    UNASSIGN_RESEARCHER_FAILED,
    SET_FILTER_BY,
    SET_SORT_BY,
    SET_SELECTED_PLACES_ACTION,
    SET_SELECTED_RESEARCHERS_ACTION,
} from './constants';

// Initialize any non-null state
const initialState = {
    status: STATUS[0],
    limit: 20,
    skip: 0,

    places: [],
    hasMorePlaces: true,
    researchers: [],
    placeDetail: {},
    filterBy: 'name',
    sortBy: 'ASC',
    allProjects: [],
    allPlaces: [],
    allZones: [],
    selectedPlaces: [],
    selectedResearchers: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_PROJECTS_REQUESTED: {
            return {
                ...state,
                error: null,
                getAllProjectsLoading: true,
            };
        }
        case GET_ALL_PROJECTS_SUCCEEDED: {
            const { projects } = action;
            return {
                ...state,
                allProjects: projects,
                getAllProjectsLoading: false,
            };
        }
        case GET_ALL_PROJECTS_FAILED: {
            return {
                ...state,
                getAllProjectsLoading: false,
            };
        }
        case GET_ALL_PLACES_REQUESTED: {
            return {
                ...state,
                error: null,
                getAllPlacesLoading: true,
            };
        }
        case GET_ALL_PLACES_SUCCEEDED: {
            const { places } = action;
            return {
                ...state,
                allPlaces: places,
                getAllPlacesLoading: false,
            };
        }
        case GET_ALL_PLACES_FAILED: {
            return {
                ...state,
                getAllPlacesLoading: false,
            };
        }

        case GET_ALL_ZONES_REQUESTED: {
            return {
                ...state,
                error: null,
                getAllZonesLoading: true,
            };
        }
        case GET_ALL_ZONES_SUCCEEDED: {
            const { zones } = action;
            return {
                ...state,
                allZones: zones,
                getAllZonesLoading: false,
            };
        }
        case GET_ALL_ZONES_FAILED: {
            return {
                ...state,
                getAllZonesLoading: false,
            };
        }

        case GET_PLACES_REQUESTED: {
            return {
                ...state,
                error: null,
                loadingPlaces: true,
                searchedOnce: true,
            };
        }
        case GET_PLACES_SUCCEEDED: {
            const { places, hasMorePlaces, skip } = action;
            return {
                ...state,
                places,
                hasMorePlaces,
                skip,
                loadingPlaces: false,
            };
        }
        case GET_PLACES_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                loadingPlaces: false,
            };
        }
        case CREATE_PROJECT_REQUESTED: {
            return {
                ...state,
                error: null,
                createProjectLoading: true,
            };
        }
        case CREATE_PROJECT_SUCCEEDED: {
            console.log('Reducer case: CREATE_PROJECT_SUCCEEDED', action);
            // Pre-pend the new Project into the state so it appears as selected in the Projects drop-down without a page reload
            const updatedAllProjects = [...state.allProjects];
            if (action.createdProject && state.allProjects) {
                updatedAllProjects.unshift(action.createdProject);
            }
            return {
                ...state,
                createProjectLoading: false,
                createProjectSuccess: true,
                allProjects: updatedAllProjects,
            };
        }
        case CREATE_PROJECT_FAILED: {
            const { error } = action;
            return {
                ...state,
                createProjectLoading: false,
                createProjectSuccess: false,
                error,
            };
        }
        case EDIT_PLACE_REQUESTED: {
            return {
                ...state,
                error: null,
                editingPlace: true,
            };
        }
        case EDIT_PLACE_SUCCEEDED: {
            let updated = [...state.places];
            for (let i = 0; i < updated.length; i++) {
                if (updated[i].id == action.place.id) {
                    updated[i] = action.place;
                }
            }
            return {
                ...state,
                editingPlace: false,
                places: updated,
            };
        }
        case EDIT_PLACE_FAILED: {
            const { error } = action;
            return {
                ...state,
                editingPlace: false,
                error,
            };
        }
        case ASSIGN_PLACES_REQUESTED: {
            return {
                ...state,
                error: null,
                assigningPlaces: true,
            };
        }
        case ASSIGN_PLACES_SUCCEEDED: {
            const { placeIds, researchers } = action;

            // Update state.placeDetail for each newly assigned Place in action.placeIds
            const updatedPlaceDetail = state.placeDetail;
            for (let placeId of placeIds) {
                if (updatedPlaceDetail[placeId]) {
                    updatedPlaceDetail[placeId].assignees.push(...researchers);
                    updatedPlaceDetail[placeId].isAssigned = true;
                }
            }

            // Update state.places
            const updatedPlaces = [];
            for (let place of state.places) {
                if (updatedPlaceDetail[place.id]) {
                    // Update the Place if we just updated the loaded placeDetail
                    place = {
                        ...updatedPlaceDetail[place.id],
                    };
                } else if (placeIds.includes(place.id)) {
                    // Set isAssigned=true even if no placeDetail has been loaded for the assigned Place
                    place.isAssigned = true;
                }

                updatedPlaces.push(place);
            }

            const response = {
                ...state,
                assigningPlaces: false,
                placeDetail: updatedPlaceDetail,
                places: updatedPlaces,
            };
            if (placeIds && placeIds.length && placeIds.length == 1) {
                response.activePlaceId = placeIds[0];
            }
            return response;
        }
        case RESET_PLACE_DETAIL: {
            return {
                ...state,
                placeDetail: {},
                searchedOnce: false,
                loadingPlaces: false,
            };
        }
        case ASSIGN_PLACES_FAILED: {
            const { error } = action;
            return {
                ...state,
                assignPlaceError: error,
                assigningPlaces: false,
            };
        }
        case RESEARCHERS_REQUESTED: {
            return {
                ...state,
                error: null,
                researchersLoading: true,
            };
        }
        case RESEARCHERS_SUCCEEDED: {
            const { researchers } = action;
            return {
                ...state,
                researchersLoading: false,
                researchers,
            };
        }
        case RESEARCHERS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                researchersLoading: false,
            };
        }
        case ASSIGNEE_REQUESTED: {
            return {
                ...state,
                error: null,
                loadingPlaceDetail: true,
            };
        }
        case ASSIGNEE_SUCCEEDED: {
            const { placeDetail } = action;
            const update = { ...state.placeDetail };
            update[placeDetail.id] = placeDetail;
            return {
                ...state,
                loadingPlaceDetail: false,
                placeDetail: update,
            };
        }
        case ASSIGNEE_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                loadingPlaceDetail: false,
            };
        }
        case UNASSIGN_RESEARCHER_REQUESTED: {
            return {
                ...state,
                error: null,
                removingResearcher: true,
            };
        }
        case UNASSIGN_RESEARCHER_SUCCEEDED: {
            const { placeId, researcherId } = action;
            const update = state.placeDetail;
            const noOfAssignees = update[placeId].assignees
                ? update[placeId].assignees.filter((a) => a.id != researcherId)
                : [];
            update[placeId] = {
                ...update[placeId],
                assignees: noOfAssignees,
                isAssigned: !!noOfAssignees.length,
            };
            const updatedPlaces = [];

            state.places.forEach((place) => {
                if (update[place.id]) {
                    place = {
                        ...update[place.id],
                    };
                }
                updatedPlaces.push(place);
            });
            return {
                ...state,
                removingResearcher: false,
                placeDetail: update,
                places: updatedPlaces,
            };
        }
        case UNASSIGN_RESEARCHER_FAILED: {
            const { error } = action;
            return {
                ...state,
                deleteResearcherError: error,
                removingResearcher: false,
            };
        }
        case DELETE_PLACE_REQUESTED: {
            return {
                ...state,
                error: null,
                deletingPlace: true,
            };
        }
        case DELETE_PLACE_SUCCEEDED: {
            const { placeId } = action;
            const update = state.placeDetail;
            delete update[placeId];
            return {
                ...state,
                deletingPlace: false,
                placeDetail: update,
                places: state.places.filter((p) => p.id != placeId),
            };
        }
        case DELETE_PLACE_FAILED: {
            const { error } = action;
            return {
                ...state,
                deleteResearcherError: error,
                deletingPlace: false,
            };
        }

        case SET_PROJECT: {
            return {
                ...state,
                selectedProject: action.project,
            };
        }

        case SET_STATUS: {
            return {
                ...state,
                status: action.status,
            };
        }

        case SET_PLACES: {
            return {
                ...state,
                places: action.places,
                hasMorePlaces: true,
            };
        }

        case SET_ZONE: {
            return {
                ...state,
                selectedZone: action.zone,
            };
        }

        case SET_ACTIVE_PLACE_ID: {
            const { id } = action;
            return {
                ...state,
                activePlaceId: id,
            };
        }
        case SET_FILTER_BY: {
            const { filterBy } = action;
            return {
                ...state,
                filterBy,
                loadingPlaces: true,
                places: [],
            };
        }
        case SET_SORT_BY: {
            const { sortBy } = action;
            return {
                ...state,
                sortBy,
                loadingPlaces: true,
                places: [],
            };
        }

        case SET_SELECTED_PLACES_ACTION: {
            const { selectedPlaces } = action;
            return {
                ...state,
                selectedPlaces: selectedPlaces,
            };
        }
        case SET_SELECTED_RESEARCHERS_ACTION: {
            const { selectedResearchers } = action;
            return {
                ...state,
                selectedResearchers: selectedResearchers,
            };
        }
        default:
            return state;
    }
}
